import { getLoginSessionLocalStorage } from './localStorage.js'
/**
 * 返回登录必要参数 key && token
 */
export const commonParams = () => {
  let loginSession = getLoginSessionLocalStorage()
  return {
    key: (loginSession ? loginSession.key : ''),
    token: (loginSession ? loginSession.token : '')
  }
}
/**
 * 返回用户相关必要参数 key && token
 */
export const userParams = () => {
  let loginSession = getLoginSessionLocalStorage()
  return {
    uid: (loginSession ? loginSession.uid : ''),
    key: (loginSession ? loginSession.key : ''),
    token: (loginSession ? loginSession.token : '')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js